export const ORDER_TOTAL_AMOUNT = 'ORDER_TOTAL_AMOUNT'
export const ORDER_CONFIRMATION_ROW = 'ORDER_CONFIRMATION_ROW'
